module.exports = __webpack_public_path__ + "img/sozialschnellgut_4_b.85d724e7.jpg";